import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { ACTION_TRANSLATIONS, ENTITY_TYPE_TRANSLATIONS, ACTION_COLORS } from '@/constants/ActivityLogConstants';
let ActivityLogDetail = class ActivityLogDetail extends Vue {
    entry;
    visible;
    dialogVisible = false;
    onVisibleChanged(val) {
        this.dialogVisible = val;
    }
    onDialogVisibleChanged(val) {
        if (!val) {
            this.$emit('close');
        }
    }
    translateAction(action) {
        return ACTION_TRANSLATIONS[action] || action;
    }
    translateEntityType(entityType) {
        return ENTITY_TYPE_TRANSLATIONS[entityType] || entityType;
    }
    getActionColor(action) {
        return ACTION_COLORS[action] || 'grey';
    }
    formatTimestamp(timestamp) {
        if (!timestamp)
            return '-';
        return moment(timestamp.toDate()).format('DD.MM.YYYY HH:mm:ss');
    }
    formatJson(value) {
        if (!value)
            return '(prázdné)';
        try {
            return JSON.stringify(value, null, 2);
        }
        catch {
            return String(value);
        }
    }
    close() {
        this.dialogVisible = false;
    }
};
__decorate([
    Prop({ default: null })
], ActivityLogDetail.prototype, "entry", void 0);
__decorate([
    Prop({ default: false })
], ActivityLogDetail.prototype, "visible", void 0);
__decorate([
    Watch('visible')
], ActivityLogDetail.prototype, "onVisibleChanged", null);
__decorate([
    Watch('dialogVisible')
], ActivityLogDetail.prototype, "onDialogVisibleChanged", null);
ActivityLogDetail = __decorate([
    Component
], ActivityLogDetail);
export default ActivityLogDetail;
